import { DOCUMENT_DISPLAY_UOM_SELECT_DATA } from "~/shared/documents/display-uom-select-options";
import type { DisplayUomOverride, DocumentDisplayUomSettings } from "~/shared/documents/schemas/document-display-uom.schema";
import { DisplayUomSchema } from "~/shared/documents/schemas/document-display-uom.schema";
import { Select } from "~/ui";

type DocumentDisplayUomModalOverrideFieldProps = {
  orgSettings: Pick<DocumentDisplayUomSettings, "allowDisplayUomOverrideOnCreate" | "displayUom">;
  value: DisplayUomOverride | undefined;
  onChange: (value: DisplayUomOverride) => void;
};

/** Create-document modal display UOM — same choices as org settings, preset to org default (SC-2494). */
export const DocumentDisplayUomModalOverrideField = ({ orgSettings, value, onChange }: DocumentDisplayUomModalOverrideFieldProps) => {
  if (!orgSettings.allowDisplayUomOverrideOnCreate) {
    return null;
  }

  const selectedValue = value ?? orgSettings.displayUom;

  return (
    <Select
      label="Display unit of measure"
      description="Same options as org document settings; defaults to the org value for this PDF."
      data={[...DOCUMENT_DISPLAY_UOM_SELECT_DATA]}
      value={selectedValue}
      onChange={next => {
        const parsed = DisplayUomSchema.safeParse(next ?? orgSettings.displayUom);
        onChange(parsed.success ? parsed.data : orgSettings.displayUom);
      }}
    />
  );
};
